function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLineHeight3 = function SvgLineHeight3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 53250"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 29301",
    style: {
      fill: "currentColor"
    },
    d: "M0 0h20v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 29302",
    transform: "translate(0 9)",
    style: {
      fill: "currentColor"
    },
    d: "M0 0h20v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 29303",
    transform: "translate(0 18)",
    style: {
      fill: "currentColor"
    },
    d: "M0 0h20v2H0z"
  })));
};

export default SvgLineHeight3;